export default "__VITE_ASSET__b84f1d38__"